import { render, staticRenderFns } from "./BoxList.vue?vue&type=template&id=d13b87ec&"
import script from "./BoxList.vue?vue&type=script&lang=ts&"
export * from "./BoxList.vue?vue&type=script&lang=ts&"
import style0 from "./BoxList.vue?vue&type=style&index=0&id=d13b87ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports